import { Injectable } from '@angular/core';
import { IComplaint } from '../interfaces/complaint.interface';
import { GenericService } from 'src/app/core/services/GenericService';
import { ApiService } from 'src/app/core/services/ApiService';

@Injectable({
  providedIn: 'root'
})
export class ComplaintsService extends GenericService<IComplaint> {
  protected readonly baseUrl = '/complaints';

  constructor(public apiService: ApiService) {
    super(apiService);
  }
}
